/* eslint-disable-next-line no-restricted-imports */
import { useIntercom as reactUseIntercom } from "react-use-intercom";

export default function useIntercom() {
  const {
    showSpace,
    showArticle: _showArticle,
    showNewMessage,
    shutdown,
    update,
    boot,
  } = reactUseIntercom();

  function showArticle(article: Parameters<typeof _showArticle>[0]) {
    _showArticle(article);
  }

  function showChat() {
    showSpace("messages");
  }

  return {
    showChat,
    showArticle,
    shutdown,
    showSpace,
    showNewMessage,
    update,
    boot,
  };
}
